module.exports = __webpack_public_path__ + "static/media/circleArrowSideOpen.63653df6.svg";